var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { CDNAsset } from './cdn-asset.js';
/** A simple component for displaying an illustration from our CDN. */
const _CDNIllustration = (_a) => {
    var { filename, ref } = _a, props = __rest(_a, ["filename", "ref"]);
    return (_jsx(CDNAsset, Object.assign({}, props, { directory: "design-assets/illustrations", filename: filename })));
};
export const CDNIllustration = styled(_CDNIllustration).withConfig({ displayName: "brc-sc-CDNIllustration", componentId: "brc-sc-5jvibz" }) ``;
//# sourceMappingURL=cdn-illustration.js.map